<div [class]="skinName">
  <div id="ideal-bank-element" #idealBankElement [ngClass]="{'ideal-auth' : (page === 'auth') }"></div>
  @if (idealEmptyError && proceedPayment) {
    <p class="help-block">{{ configService.localeKeys?.pay_stripe_err_select_bank}}</p>
  }
</div>